import type { GlobalSearchResultItem } from './types';

export const rankResults = (results: GlobalSearchResultItem[]): GlobalSearchResultItem[] => {
  return results.map((result, index) => ({ ...result, rank: index + 1 }));
};
